module.exports = __webpack_public_path__ + "static/media/xlsx.fec52bd7.svg";